import ResetPasswordReducer from './ResetPasswordReducer';

export default from './ResetPasswordContainer';
export const ResetPasswordReducers = {
  ResetPasswordReducer,
};
